<ng-container *ngIf="showHeader">
    <img class="banner-img center-block div-print" src="https://gestionatupyme-public.s3.amazonaws.com/banner.png"
        alt="" />
</ng-container>

<mat-card class="simple-card mx-auto">
    <mat-card-content>
        <div class="row">

            <div class="col-12 d-flex justify-content-between" *ngIf="showHeader">
                <h1>Reporte Contribuciones</h1>
                <button
                    mat-flat-button
                    class="custom-button-primary no-print"
                    (click)="generatePDF()"
                    [disabled]="isPDFLoading">
                    <mat-icon aria-hidden="false" aria-label="Icono de descarga" fontIcon="get_app" class="icon-download"></mat-icon>
                    Descargar Resultado
                    <mat-icon *ngIf="isPDFLoading" iconPositionEnd>
                        <mat-spinner class="custom-white-spinner" diameter="15"></mat-spinner>
                    </mat-icon>
                </button>
            </div>

            <div class="col-12 my-3" *ngIf="showHeader">
                <mat-chip-set aria-label="Rut principal">
                    <mat-chip class="chip-rut">
                        <strong>RUT:</strong> {{content.DatosBasicosSolicitud.Rut |
                        number:'1.0-0'}}-{{content.DatosBasicosSolicitud.DV | uppercase}}
                    </mat-chip>
                </mat-chip-set>
            </div>

            <div class="col-12">

                <div class="resumen-cards no-print">
                    <mat-card class="resume-card blue-card">
                        <mat-card-content class="p-4 h-100 d-flex justify-content-between align-items-center">
                            <div class="h-100 d-flex flex-column justify-content-between">
                                <span class="resume-card-title font-weight-500">N° de propiedades</span>
                                <span class="resume-card-value">{{ numPropiedades }}</span>
                            </div>
                            <mat-icon class="card-icon d-flex align-items-center justify-content-center">home</mat-icon>
                        </mat-card-content>
                    </mat-card>

                    <mat-card class="resume-card green-card">
                        <mat-card-content class="p-4 h-100 d-flex justify-content-between align-items-center">
                            <div class="h-100 d-flex flex-column justify-content-between">
                                <span class="resume-card-title font-weight-500">Total cuotas vigentes</span>
                                <span class="resume-card-value">${{ totalCuotasVigentes | number }}</span>
                            </div>
                            <mat-icon class="card-icon d-flex align-items-center justify-content-center">check_circle</mat-icon>
                        </mat-card-content>
                    </mat-card>

                    <mat-card class="resume-card red-card">
                        <mat-card-content class="p-4 h-100 d-flex justify-content-between align-items-center">
                            <div class="h-100 d-flex flex-column justify-content-between">
                                <span class="resume-card-title font-weight-500">Total cuotas vencidas</span>
                                <span class="resume-card-value">${{ totalCuotasVencidas | number }}</span>
                            </div>
                            <mat-icon class="card-icon d-flex align-items-center justify-content-center">error</mat-icon>
                        </mat-card-content>
                    </mat-card>
                </div>

                <mat-card class="mt-5 no-print">
                    <mat-card-header>
                        <mat-card-title class="font-size-title-card">
                            <mat-chip class="chip-info mr-2"><i class="fa fa-info" aria-hidden="true"></i></mat-chip>
                            <strong>Propiedades</strong>
                        </mat-card-title>
                    </mat-card-header>

                    <mat-card-content class="p-5">
                        <mat-accordion>
                            <mat-expansion-panel *ngFor="let i = index; let vivienda of viviendasConTotales">
                                <mat-expansion-panel-header>
                                    <mat-panel-title>
                                        {{ vivienda.descripcionComuna }} {{ vivienda.rol }}
                                    </mat-panel-title>
                                </mat-expansion-panel-header>
                                <div class="p-5 w-100">
                                    <div class="two-equal-columns-grid border p-5">
                                        <div class="grid">
                                            <div class="font-weight-500">Dirección:</div>
                                            <div>{{ vivienda.direccion }}</div>

                                            <div class="font-weight-500">Propietario:</div>
                                            <div>{{ vivienda.nombrePropietario }}</div>

                                            <div class="font-weight-500">Destino:</div>
                                            <div>{{ vivienda.destino }}</div>
                                        </div>
                                        <div class="grid">
                                            <div class="font-weight-500 error-text">Total cuotas vencidas:</div>
                                            <div class="font-weight-500 error-text">${{ vivienda.totalCuotasVencidas | number: '1.0-0' }}</div>

                                            <div class="font-weight-500 success-text">Total cuotas vigentes:</div>
                                            <div class="font-weight-500 success-text">${{ vivienda.totalCuotasVigentes | number: '1.0-0' }}</div>
                                        </div>
                                    </div>
                                    <div class="border grid p-5 mt-4">
                                        <div class="font-weight-bold full-width">Cuotas</div>

                                        <div class="table-responsive border rounded full-width">
                                            <table mat-table [dataSource]="vivienda.cuotas" class="custom-print-table">
                                                <ng-container matColumnDef="año">
                                                    <th mat-header-cell *matHeaderCellDef>Año</th>
                                                    <td mat-cell *matCellDef="let element">{{ element.agno }}
                                                    </td>
                                                </ng-container>

                                                <ng-container matColumnDef="numCuota">
                                                    <th mat-header-cell *matHeaderCellDef>N° Cuota</th>
                                                    <td mat-cell *matCellDef="let element">{{ element.cuota }}
                                                    </td>
                                                </ng-container>

                                                <ng-container matColumnDef="condicion">
                                                    <th mat-header-cell *matHeaderCellDef>Condición</th>
                                                    <td mat-cell *matCellDef="let element">{{ element.condicion }}</td>
                                                </ng-container>

                                                <ng-container matColumnDef="vencimiento">
                                                    <th mat-header-cell *matHeaderCellDef>Vencimiento</th>
                                                    <td mat-cell *matCellDef="let element">{{ element.fechaVencimiento | date: 'dd/MM/yyyy' }}</td>
                                                </ng-container>

                                                <ng-container matColumnDef="valorBase">
                                                    <th mat-header-cell *matHeaderCellDef>Valor base</th>
                                                    <td mat-cell *matCellDef="let element">${{ element.valor | number: '1.0-0' }}</td>
                                                </ng-container>

                                                <ng-container matColumnDef="reajustes">
                                                    <th mat-header-cell *matHeaderCellDef>Reajustes</th>
                                                    <td mat-cell *matCellDef="let element">${{ element.reajustes | number: '1.0-0' }}</td>
                                                </ng-container>

                                                <ng-container matColumnDef="intereses">
                                                    <th mat-header-cell *matHeaderCellDef>Intereses</th>
                                                    <td mat-cell *matCellDef="let element">${{ element.intereses | number: '1.0-0' }}</td>
                                                </ng-container>

                                                <ng-container matColumnDef="condonacion">
                                                    <th mat-header-cell *matHeaderCellDef>Condonación</th>
                                                    <td mat-cell *matCellDef="let element">${{ element.condonacion | number: '1.0-0' }}</td>
                                                </ng-container>

                                                <ng-container matColumnDef="totalAPagar">
                                                    <th mat-header-cell *matHeaderCellDef>Total a pagar</th>
                                                    <td mat-cell *matCellDef="let element">${{ element.totalPago | number: '1.0-0' }}</td>
                                                </ng-container>

                                                <tr mat-header-row *matHeaderRowDef="cuotasDisplayedColumns">
                                                </tr>
                                                <tr mat-row
                                                    *matRowDef="let row; columns: cuotasDisplayedColumns;"></tr>

                                                <tr class="mat-mdc-row" *matNoDataRow>
                                                    <td class="mat-mdc-cell text-center font-weight-500"
                                                        [attr.colspan]="cuotasDisplayedColumns.length">
                                                        No hay datos disponibles
                                                    </td>
                                                </tr>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </mat-expansion-panel>
                        </mat-accordion>
                    </mat-card-content>
                </mat-card>
            </div>

            <!-- print section -->

            <div class="col-12 div-print">
                <mat-card class="mt-5 border">
                    <mat-card-header>
                        <mat-card-title class="font-size-title-card">
                            <mat-chip class="chip-info mr-2"><i class="fa fa-info" aria-hidden="true"></i></mat-chip>
                            <strong>Resumen general</strong>
                        </mat-card-title>
                    </mat-card-header>

                    <mat-card-content class="p-3">
                        <div class="p-5 w-100">
                            <div class="grid border p-5">
                                <div class="grid">
                                    <div class="font-weight-500 info-text">N° de Propiedades:</div>
                                    <div class="font-weight-500 info-text">{{ numPropiedades }}</div>

                                    <div class="font-weight-500 success-text">Total cuotas vigentes:</div>
                                    <div class="font-weight-500 success-text">${{ totalCuotasVigentes | number: '1.0-0' }}</div>

                                    <div class="font-weight-500 error-text">Total cuotas vencidas:</div>
                                    <div class="font-weight-500 error-text">${{ totalCuotasVencidas | number: '1.0-0' }}</div>
                                </div>
                            </div>
                        </div>
                    </mat-card-content>
                </mat-card>

                <mat-card class="mt-5">
                    <mat-card-header>
                        <mat-card-title class="font-size-title-card">
                            <mat-chip class="chip-info mr-2"><i class="fa fa-info" aria-hidden="true"></i></mat-chip>
                            <strong>Propiedades</strong>
                        </mat-card-title>
                    </mat-card-header>

                    <mat-card-content class="p-3">
                        <div class="p-5 border w-100 no-break" *ngFor="let i = index; let vivienda of viviendasConTotales">
                            <div class="mb-3">
                                <mat-chip class="chip-info mr-2"><i class="fa fa-info" aria-hidden="true"></i></mat-chip>
                                <strong>{{ vivienda.descripcionComuna }} {{ vivienda.rol }}</strong>
                            </div>
                            <div class="two-equal-columns-grid border p-5">
                                <div class="grid">
                                    <div class="font-weight-500">Dirección:</div>
                                    <div>{{ vivienda.direccion }}</div>

                                    <div class="font-weight-500">Propietario:</div>
                                    <div>{{ vivienda.nombrePropietario }}</div>

                                    <div class="font-weight-500">Destino:</div>
                                    <div>{{ vivienda.destino }}</div>
                                </div>
                                <div class="grid">
                                    <div class="font-weight-500 error-text">Total cuotas vencidas:</div>
                                    <div class="font-weight-500 error-text">${{ vivienda.totalCuotasVencidas | number: '1.0-0' }}</div>

                                    <div class="font-weight-500 success-text">Total cuotas vigentes:</div>
                                    <div class="font-weight-500 success-text">${{ vivienda.totalCuotasVigentes | number: '1.0-0' }}</div>
                                </div>
                            </div>
                            <div class="border grid p-5 mt-4">
                                <div class="font-weight-bold full-width">Cuotas</div>

                                <div class="table-responsive border rounded full-width">
                                    <table mat-table [dataSource]="vivienda.cuotas" class="custom-print-table">
                                        <ng-container matColumnDef="año">
                                            <th mat-header-cell *matHeaderCellDef>Año</th>
                                            <td mat-cell *matCellDef="let element">{{ element.agno }}
                                            </td>
                                        </ng-container>

                                        <ng-container matColumnDef="numCuota">
                                            <th mat-header-cell *matHeaderCellDef>N° Cuota</th>
                                            <td mat-cell *matCellDef="let element">{{ element.cuota }}
                                            </td>
                                        </ng-container>

                                        <ng-container matColumnDef="condicion">
                                            <th mat-header-cell *matHeaderCellDef>Condición</th>
                                            <td mat-cell *matCellDef="let element">{{ element.condicion }}</td>
                                        </ng-container>

                                        <ng-container matColumnDef="vencimiento">
                                            <th mat-header-cell *matHeaderCellDef>Vencimiento</th>
                                            <td mat-cell *matCellDef="let element">{{ element.fechaVencimiento | date: 'dd/MM/yyyy' }}</td>
                                        </ng-container>

                                        <ng-container matColumnDef="valorBase">
                                            <th mat-header-cell *matHeaderCellDef>Valor base</th>
                                            <td mat-cell *matCellDef="let element">${{ element.valor | number: '1.0-0' }}</td>
                                        </ng-container>

                                        <ng-container matColumnDef="reajustes">
                                            <th mat-header-cell *matHeaderCellDef>Reajustes</th>
                                            <td mat-cell *matCellDef="let element">${{ element.reajustes | number: '1.0-0' }}</td>
                                        </ng-container>

                                        <ng-container matColumnDef="intereses">
                                            <th mat-header-cell *matHeaderCellDef>Intereses</th>
                                            <td mat-cell *matCellDef="let element">${{ element.intereses | number: '1.0-0' }}</td>
                                        </ng-container>

                                        <ng-container matColumnDef="condonacion">
                                            <th mat-header-cell *matHeaderCellDef>Condonación</th>
                                            <td mat-cell *matCellDef="let element">${{ element.condonacion | number: '1.0-0' }}</td>
                                        </ng-container>

                                        <ng-container matColumnDef="totalAPagar">
                                            <th mat-header-cell *matHeaderCellDef>Total a pagar</th>
                                            <td mat-cell *matCellDef="let element">${{ element.totalPago | number: '1.0-0' }}</td>
                                        </ng-container>

                                        <tr mat-header-row *matHeaderRowDef="cuotasDisplayedColumns">
                                        </tr>
                                        <tr mat-row
                                            *matRowDef="let row; columns: cuotasDisplayedColumns;"></tr>

                                        <tr class="mat-mdc-row" *matNoDataRow>
                                            <td class="mat-mdc-cell text-center font-weight-500"
                                                [attr.colspan]="cuotasDisplayedColumns.length">
                                                No hay datos disponibles
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </mat-card-content>
                </mat-card>
            </div>

        </div>
    </mat-card-content>
</mat-card>